module.exports = __webpack_public_path__ + "static/media/Check.23cfd688.svg";